import iconFilter from '../../assets/icons/icon-filter.svg';
import iconArrow from '../../assets/icons/icon-arrow.svg';
import {Image} from '@shopify/hydrogen';
import {Fragment, useCallback} from 'react';
// @ts-expect-error @headlessui/react
import {Listbox, Transition} from '@headlessui/react';
import {DATA_TEST_IDS, SORT_OPTIONS} from '~/lib/const';
import clsx from 'clsx';

export function ProductListHeading({
  sort,
  hideFilters,
  setHideFilters,
  openDrawer,
  onChangeSort,
}: {
  sort: string;
  hideFilters: boolean;
  setHideFilters: React.Dispatch<React.SetStateAction<boolean>>;
  openDrawer: () => void;
  onChangeSort: (value: string) => void;
}) {
  const toggleFilters = useCallback(() => {
    setHideFilters((prev) => !prev);
  }, [setHideFilters]);

  const openDrawerCallback = useCallback(() => {
    openDrawer();
  }, [openDrawer]);

  return (
    <div
      data-testid={DATA_TEST_IDS.PRODUCT_LIST_HEADING}
      className="flex text-16/22 xl:text-20/27"
    >
      <button
        data-testid={DATA_TEST_IDS.BUTTON('show-hide-filters')}
        type="button"
        className="hidden items-center xl:flex"
        onClick={toggleFilters}
      >
        <span className="font-header font-bold">
          {hideFilters ? 'SHOW' : 'HIDE'} FILTERS
        </span>
        <Image
          loading="lazy"
          src={iconFilter}
          width={23.25}
          height={15.5}
          alt="HIDE FILTERS"
          className="ml-3"
        />
      </button>

      <button
        data-testid={DATA_TEST_IDS.BUTTON('sort-and-filter')}
        type="button"
        className="flex items-center xl:hidden"
        onClick={openDrawerCallback}
      >
        <Image
          loading="lazy"
          src={iconFilter}
          width={23.25}
          height={15.5}
          alt="HIDE FILTERS"
          className="mr-[9px]"
        />
        <span className="font-header font-bold">SORT & FILTER</span>
      </button>

      <div className="ml-[42px] relative hidden xl:flex">
        <Listbox defaultValue={sort} value={sort} onChange={onChangeSort}>
          <Listbox.Button className="flex w-full items-center">
            <span
              data-testid={DATA_TEST_IDS.BUTTON('sort-by')}
              className="font-header font-bold whitespace-nowrap"
            >
              SORT BY
            </span>
            <Image
              loading="lazy"
              src={iconArrow}
              width={15.11}
              height={8.86}
              alt="SORT BY"
              className="ml-[14px]"
            />
          </Listbox.Button>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Listbox.Options className="absolute right-0 mt-2 w-60 origin-top-right rounded-md bg-white drop-shadow-dropdown ring-1 ring-black ring-opacity-5 focus:outline-none z-50 border border-gray-100 p-5">
              {SORT_OPTIONS.map((sortOption) => (
                <Listbox.Option
                  data-testid={DATA_TEST_IDS.SORT_LABEL(sortOption.label)}
                  key={sortOption.label}
                  value={sortOption.value}
                  className={clsx(
                    'group flex w-full items-center rounded-md px-5 py-2 font-header font-bold text-18/32 cursor-pointer hover:bg-gray-200 hover:text-black',
                    sort === sortOption.value
                      ? 'bg-gray-200 text-black'
                      : 'text-gray-400',
                  )}
                >
                  {sortOption.label}
                </Listbox.Option>
              ))}
            </Listbox.Options>
          </Transition>
        </Listbox>
      </div>
    </div>
  );
}
